import { Admin, Resource, CustomRoutes } from "react-admin";
import { Route } from "react-router-dom";
import { Layout } from "./Layout";
import { theme } from "./theme";
import { dataProvider } from "./dataProvider";
import { RoundList } from "./resources/oracle/RoundList";
import { RoundShow } from "./resources/oracle/RoundShow";
import { BetList } from "./resources/oracle/BetList";
import { BetShow } from "./resources/oracle/BetShow";
import { WalletRequestList } from "./resources/oracle/WalletRequestList";
import { GameConfigList } from "./resources/oracle/GameConfigList";
import { OperatorList } from "./resources/oracle/OperatorList";
import { UserList } from "./resources/oracle/UserList";
import { FdbDashboard } from "./resources/fdb/FdbDashboard";
import { FdbRoundShow } from "./resources/fdb/FdbRoundShow";
import { FdbGameConfigs } from "./resources/fdb/FdbGameConfigs";
import { ReconPage } from "./resources/recon/ReconPage";
import { OperatorStatsPage } from "./resources/oracle/OperatorStatsPage";

export const App = () => (
  <Admin
    layout={Layout}
    theme={theme}
    dataProvider={dataProvider}
    darkTheme={theme}
    requireAuth={false}
  >
    <Resource
      name="db-rounds"
      list={RoundList}
      show={RoundShow}
      options={{ label: "Rounds" }}
    />
    <Resource
      name="db-bets"
      list={BetList}
      show={BetShow}
      options={{ label: "Bets" }}
    />
    <Resource
      name="db-wallet-requests"
      list={WalletRequestList}
      options={{ label: "Wallet Requests" }}
    />
    <Resource
      name="db-users"
      list={UserList}
      options={{ label: "Users" }}
    />
    <Resource
      name="db-operators"
      list={OperatorList}
      options={{ label: "Operators" }}
    />
    <Resource
      name="db-game-configs"
      list={GameConfigList}
      options={{ label: "Game Configs" }}
    />
    <CustomRoutes>
      <Route path="/fdb" element={<FdbDashboard />} />
      <Route path="/fdb/rounds/:roundId" element={<FdbRoundShow />} />
      <Route path="/fdb/game-configs" element={<FdbGameConfigs />} />
      <Route path="/recon" element={<ReconPage />} />
      <Route path="/operator-stats" element={<OperatorStatsPage />} />
    </CustomRoutes>
  </Admin>
);
